import { GrafanaThemeType } from '@grafana/data';
/**
 * @deprecated use theme.isLight ? or theme.isDark instead
 */
export var selectThemeVariant = function (variants, currentTheme) {
    return variants[currentTheme || GrafanaThemeType.Dark];
};
//# sourceMappingURL=selectThemeVariant.js.map